// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

export enum ElevatorService {
  Auto = 0,
  Norm = 1,
  Run = 2,
  Oos = 3,
  Ins = 4,
  InsCons = 5,
  CtIns = 6,
  CtInsCons = 7,
  CpIns = 8,
  CpInsCons = 9,
  HaIns = 10,
  HaInsCons = 11,
  MrIns = 12,
  MrInsCons = 13,
  MOS = 14,
  Ind = 15,
  Test = 16,
  TestSwitch = 17,
  FireMain = 18,
  FireAlt = 19,
  FirePhase1 = 20,
  FirePhase2 = 21,
  HospitalPhase1 = 22,
  HospitalPhase2 = 23,
  Shuttle = 24,
  Sabbath = 25,
  Construction = 26,
  Earthquake = 27,
  L = 28,
  Attendant = 29,
  CodeBlue = 30,
  Homing = 31,
  ResetGoingUp = 32,
  ResetGoingDown = 33,
  Stalled = 34,
  CarToLobby = 35,
  LoadBypass = 36,
  LoadWeighingOverload = 37,
  MedicalEmergency = 38,
  CalibrateLoadWeigher = 39,
  CarSwitchElevatorOff = 40,
  HallSwitchElevatorOff = 41,
  LowPressure = 42,
  HospitalServiceOperation = 43,
  VIP = 44,
  SecurityRecall = 45,
  TugServiceOperation = 46,
  HotOilOperation = 47,
  RiotControl = 48,
  CarSwitchElevatorOff2 = 49,
  Heliport = 50,
  Cfss0_Phase1 = 51,
  Cfss0_Transition = 52,
  Cfss0_Phase2 = 53,
  EMS_Phase1 = 54,
  Unknown = 55,
  NAV = 56,
  EmergencyMedicalTec = 57,
  EPC = 58,
  CorrectionRun = 59,
  EmergencyPowerReturn = 60,
  EmergencyPowerWait = 61,
  EmergencyPower = 62,
  OverloadedCar = 63,
  DoorTimeClose = 64,
  DoorTimeOpen = 65,
  CancelHallCalls = 66,
  LoadNonStop = 67,
  ModerateIncomingTraffic = 68,
  DoorCloseProtection = 69,
  AntiNusianceOperation = 70,
  ARD = 71,
  Parked = 72,
  Idle = 73,
  ParkingSwitch = 74,
  GCB = 75,
  Initializing = 76,
  EmergencyStopButton = 77,
  ACP = 78,
  WildCarOperation = 79,
  DriveBrakeFailure = 80,
  EFP = 81,
  CRL = 82,
  ConcealedRiserOperation = 83,
  CarEmergency = 84,
  DoorOpenSwitch = 85,
  WildCarService = 86,
  REC = 87,
  OHT = 88,
  ARE = 89,
  EPD = 90,
  JudgeCar = 91,
  EmergencyRecall = 92,
  Priority = 93,
  FirePreAlarm = 94,
  Night = 95,
  Building = 96,
  Special = 97,
  ServiceProtection = 98,
  StopSwitch = 99,
  DispatchLoss = 100,
  LobbyIndepedent = 101,
  DoorDisconnect = 102,
  RearDoorDisconnect = 103,
  ControlledShutdown = 104,
  DriveFault = 105,
  Initialization = 106,
  PowerLoss = 107,
  DriveOff = 108,
  Safeties = 109,
  Reset = 110,
  ShuntTrip = 111,
  LowOil = 112,
  Access = 113,
  NegativePressure = 114,
  AuxillaryPowerLanding = 115,
  Dead = 116,
  CriticalFail = 117,
  DownwardStall = 118,
  UpWardStall = 119,
  Disabled = 120,
  TestDisplay = 121,
  CloseFailure = 122,
  NoStarter = 123,
  StuckStarter = 124,
  CarCaptureSecurity = 125,
  Capture = 126,
  Security = 127,
  ViscosityCondition = 128,
  MedicalEmergencyPhase1 = 129,
  MedicalEmergencyPhase2 = 130,
  TelescopicResynchronizationInProgress = 131,
  TelescopicResynchronizationRecall = 132,
  ServiceDrive = 133,
  Freight = 134,
  PriorityLandingHigh = 135,
  PriorityLandingLow = 136,
  Simplex = 137,
  AutoReturnDrive = 138,
  LandingCallDisconnect = 139,
  PowerOk = 140,
  Started = 141,
  Stopping = 142,
  BrakeBurnishing = 143,
  Acceleration = 144,
  Deceleration = 145,
  Ready = 146,
  Continous = 147,
  CLS = 148,
  Stopped = 149,
  NormEnabled = 150,
  CounterWeightDerailment = 151,
  HomingAndShutdown = 152,
  HiWind = 153,
  Storm = 154,
  Reduced = 155,
  CCP1 = 156,
  CarCln = 157,
  OOSP1 = 158,
  Inv = 159,
  Prc = 160,
  HatchAccess = 161,
  CarHospital = 162,
  HallShutdownSwitch = 163,
  NoCommunication = 164,
  InitFailiure = 165,
  AutomaticShutdown = 166,
  StartProtect = 167,
  OverspeedFault = 168,
  BrakeFault = 169,
  MotionFault = 170,
  DoorZoneFault = 171,
  HallIndependentService = 172,
  CommunicationLossToGroup = 173,
  CarInGroupService = 174,
  DoorHoldActive = 175,
  MassMedInCar = 176,
  RunMonitorFailure = 177,
  FrontHoistDoorWatch = 178,
  SelectorFault = 179,
  RearHoistDoorWatchdog = 180,
  FrontCarDoorWatchdog = 181,
  RearCarDoorWatchdog = 182,
  FrontDoorNudging = 183,
  RearDoorNudging = 184,
  DiagnosticsCarLockout = 185,
  InitializationShutdown = 186,
  LoadweigherShutdown = 187,
  CheckedRedundancy = 188,
  CarCycling = 189,
  TelescopingJackResync = 190,
  InconspicuousRiser = 191,
  RetiringCamFailure = 192,
  NextUp = 193,
  TransferFloor = 194,
  FrontDoorHold = 195,
  RearDoorHold = 196,
  FrontDoorCommunicationLoss = 197,
  RearDoorCommunicationLoss = 198,
  ExternalControlOfCall = 199,
  ExternalControlOfFrontDoor = 200,
  ExternalControlOfRearDoor = 201,
  ExternalSecurity = 202,
  EmergencyDispatch = 203,
  NeoNatalService = 204,
  LobbyStop = 205,
  UnintendedMotion = 206,
  RescueOperation = 207,
  LoadWeighingByPass = 208,
  Earthquake2 = 209,
  SafetyStringOpen = 210,
  Cfss1_Phase1 = 211,
  Cfss1_Phase2 = 212
}
